<script setup lang="ts">
import LoginForm from '~/components/auth/LoginForm.vue';
import RegisterForm from '~/components/auth/RegisterForm.vue';
import { useAuthStore } from '~/stores/AuthStore';

const authStore = useAuthStore();
</script>

<template>
  <LoginForm v-if="authStore.open === 'login'" />
  <RegisterForm v-if="authStore.open === 'register'" />
</template>

<style scoped lang="scss">
.auth {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;

  .register-error {
    width: 100%;
    text-align: start;
    color: $text-status-destructive;
  }

  .auth__header {
    text-align: center;

    img,
    h3 {
      margin-bottom: 12px;
    }

    h3 {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
    }
  }

  .auth__buttons-id {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .auth__actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    .new-button {
      width: 100%;
    }
  }

  .auth__agreement {
    text-align: center;
    color: $foreground-gray;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
  }

  .auth__footer {
    font-size: 14px;
    line-height: 20px;
    color: #9691f0;
  }

  p {
    font-size: 16px;
    margin-bottom: 22px;
    text-align: center;
  }

  .error {
    color: $text-status-destructive;
  }

  .password-label {
    position: relative;

    input {
      width: 100%;
    }
  }

  label {
    margin-bottom: 12px;
    width: 100%;

    input {
      background: white;
      padding: 17px 20px;
      border-radius: 10px;
      border: 1px solid $foreground-theme;
      width: 100%;

      &::placeholder {
        color: $foreground-theme;
      }

      &:focus {
        outline: 2px solid $foreground-theme;
      }
    }
  }

  small {
    margin-top: 22px;
    font-size: 13px;
    line-height: 130%;
    text-align: center;
    display: block;

    a {
      text-decoration: underline;
    }
  }
}
</style>
